module.exports = __webpack_public_path__ + "static/img/evse.ee5a0bd4.png";